import { FC } from "react";
import {
    IonCard,
    IonContent,
    IonItem,
    IonPage,
    useIonRouter,
} from "@ionic/react";
import { HeaderComponent } from "../../../components";
import { routes } from "../../../route/constants";
import { useTranslation } from "react-i18next";
import assignrSquareLogo from "../../../assets/images/icon/assignr-square-icon.png";
import refInsightSquareLogo from "../../../assets/images/icon/refinsight-square-icon.png";
import refAssistLogo from "../../../assets/images/icon/refassist-logo-small.png";
export const Integrations: FC = () => {
    const { t } = useTranslation();
    const route = useIonRouter();
    return (
        <IonPage>
            <HeaderComponent
                showBackButton
                defaultHref={routes.refsixMore}
                title={t("general.integrations")}
                titleTestId="integrations-page-header"
            />
            <IonContent>
                <IonCard>
                    <IonItem
                        button
                        lines="none"
                        data-testid="button-integration-assignr"
                        onClick={() =>
                            route.push(routes.refsixAssignrIntegration)
                        }
                    >
                        Assignr
                        <img
                            alt="Assignr"
                            style={{ width: "21px", marginLeft: 10 }}
                            src={assignrSquareLogo}
                        />
                    </IonItem>
                </IonCard>

                <IonCard>
                    <IonItem
                        button
                        lines="none"
                        data-testid="button-integration-dbu"
                        onClick={() => route.push(routes.refsixDbuIntegration)}
                    >
                        DBU 🇩🇰
                    </IonItem>
                </IonCard>

                <IonCard>
                    <IonItem
                        button
                        lines="none"
                        data-testid="button-integration-knvb"
                        onClick={() => route.push(routes.refsixKnvbIntegration)}
                    >
                        KNVB 🇳🇱
                    </IonItem>
                </IonCard>

                <IonCard>
                    <IonItem
                        button
                        lines="none"
                        data-testid="button-integration-refassist"
                        onClick={() =>
                            route.push(routes.refsixRefAssistIntegration)
                        }
                    >
                        RefAssist
                        <img
                            alt="RefAssist"
                            style={{
                                width: 21,
                                marginLeft: 10,
                            }}
                            src={refAssistLogo}
                        />
                    </IonItem>
                </IonCard>

                <IonCard>
                    <IonItem
                        button
                        lines="none"
                        data-testid="button-integration-refinsight"
                        onClick={() =>
                            route.push(routes.refsixRefInsightIntegration)
                        }
                    >
                        Ref Insight&nbsp;
                        <img
                            alt="Ref Insight"
                            style={{
                                width: 21,
                                marginLeft: 10,
                            }}
                            src={refInsightSquareLogo}
                        />
                    </IonItem>
                </IonCard>

                {/* Hidden in initial release */}
                <IonCard hidden={true}>
                    <IonItem
                        button
                        lines="none"
                        data-testid="button-integration-stack-sports"
                        onClick={() =>
                            route.push(routes.refsixStackSportsIntegration)
                        }
                    >
                        Stack Officials 🇺🇸 🇨🇦
                    </IonItem>
                </IonCard>
            </IonContent>
        </IonPage>
    );
};
